import React from "react";
import { useNavigate } from "react-router-dom";

// Components
import LandingHeader from "~/common/components/LandingHeader";
import LandingFooter from "~/common/components/LandingFooter";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import { Helmet } from "react-helmet-async";
import { getTitle } from "~/utils/getTitle";
import { ProFreeIcon } from "~/assets/svg/InterfacesIcon";
import { useAtom } from "jotai";
import { promotionModalAtom } from "~/atoms/Landing";
import { useGlobalStore } from "~/store";
import useScrollTop from "~/common/hooks/useScrollTop";
import { Trans, useTranslation } from "react-i18next";

const LandingLayout = ({ children }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const [promotionModal, setPromotionModal] = useAtom(promotionModalAtom);

	const [
		{
			user: { info },
		},
	] = useGlobalStore();

	useScrollTop();

	return (
		<>
			<main className={"p__newMain"}>
				<LandingHeader />
				{children}
				<LandingFooter />
			</main>

			{/* Pro Free 안내모달 */}
			<ModalTemplate
				modalState={promotionModal}
				setModalToggle={setPromotionModal}
				width={430}
				height={264}
				className="pro-free-modal"
			>
				<Helmet>
					<title>{getTitle(t("Landing.LandingLayout.ProFreeModal.title"))}</title>
				</Helmet>
				<div className="modal-content">
					<ProFreeIcon />
					<p className="title pre">
						<Trans
							i18nKey="Landing.LandingLayout.ProFreeModal.content"
							components={[<b />]}
						/>
					</p>
				</div>
				<div className="modal-footer">
					<button
						type="button"
						className="btn__solid"
						color="gray"
						onClick={() => {
							setPromotionModal(false);
						}}
					>
						{t("button.close")}
					</button>
					<button
						type="button"
						className="btn__solid"
						color="primary"
						onClick={() => {
							setPromotionModal(false);
							navigate(
								!info.role
									? "/join"
									: info.role === "admin"
										? "/myPage/admin/license"
										: "/dashboard"
							);
						}}
					>
						{t("Landing.LandingLayout.ProFreeModal.btn-free")}
					</button>
				</div>
			</ModalTemplate>
		</>
	);
};

export default LandingLayout;
